import React from 'react';
import { OperatorType, SwitchToggle } from '@fabric-ui/components';
import { Box } from '@mui/material';
import DeleteAddFilter from '../DeleteAddFilter';
import { useExpressionBuilder } from '../ExpressionBuilderContext';
import { useFilterConfig } from '../FilterContext';

interface FilterRowActionsProps {
  addLogicalExpression?: () => void;
  enableFilter: boolean;
  level: number;
  onDelete: () => void;
  onEnableChange: (enabled: boolean) => void;
  placement: 'header' | 'row';
  rootOperator: OperatorType | 'expression';
  showDeleteAddFilter: boolean;
  showDisableToggle: boolean;
}

export const FilterRowActions: React.FC<FilterRowActionsProps> = ({
  addLogicalExpression,
  enableFilter,
  level,
  onDelete,
  onEnableChange,
  placement,
  rootOperator,
  showDeleteAddFilter,
  showDisableToggle,
}) => {
  const { fieldDescription, isOverExpressionsLimit, readOnly = false } = useExpressionBuilder();
  const { disabled } = useFilterConfig();

  if (placement === 'header') {
    return fieldDescription ? (
      <Box className="ml-3 mt-3 flex w-[95%] items-center justify-between">
        {fieldDescription}
        {showDisableToggle && <SwitchToggle value={enableFilter} onChange={onEnableChange} label={enableFilter ? 'On' : 'Off'} />}
      </Box>
    ) : null;
  }

  if (!showDeleteAddFilter || readOnly) return null;

  return (
    <DeleteAddFilter
      level={level}
      oppositeOperator={rootOperator === OperatorType.OR ? OperatorType.AND : OperatorType.OR}
      rootOperator={rootOperator}
      onAdd={addLogicalExpression}
      onDelete={onDelete}
      disabled={isOverExpressionsLimit || disabled}
    />
  );
};
